import request from '@/utils/request';

// 创建任务
export function createTask(data) {
  return request({
    url: '/tasks',
    method: 'post',
    data
  });
}

// 更新任务状态
export function updateTaskStatus(id, status) {
  return request({
    url: `/tasks/${id}/status`,
    method: 'put',
    params: { status: status.trim() } // 状态值去空格
  });
}

// 获取用户待办任务
export function getUserTasks(userId) {
  return request({
    url: `/tasks/user/${userId.trim()}`, // 用户ID去空格
    method: 'get'
  });
}

// 获取用户待审批任务
export function getUserApprovalTasks(userId) {
  return request({
    url: `/tasks/approval/${userId.trim()}`,
    method: 'get'
  });
}

// 保存任务完成情况
export function saveCompleteDesc(id, completeDescription) {
  return request({
    url: `/tasks/${id}/complete-desc`,
    method: 'put',
    params: { completeDescription: completeDescription.trim() }
  });
}

export function saveAuditOpinion(id, auditLevel, auditOpinion) {
  return request({
    url: `/tasks/${id}/audit-opinion`,
    method: 'put',
    params: { auditLevel: auditLevel, auditOpinion: auditOpinion.trim() }
  });
}

// 获取企业微信部门用户
export function getDepartmentUsers(departmentId, fetchChild = false) {
  return request({
    url: '/wechat/department/users',
    method: 'get',
    params: { departmentId, fetchChild }
  });
}

// ===== 新增：上传任务文件 =====
/**
 * 上传任务相关文件
 * @param {FormData} formData - 包含taskId和files的表单数据
 * @returns {Promise} - 接口返回Promise
 */
export function uploadTaskFile(formData) {
  // 校验FormData格式
  if (!(formData instanceof FormData)) {
    console.error('uploadTaskFile参数错误：必须传入FormData对象');
    return Promise.reject(new Error('文件上传参数格式错误，请传入FormData对象'));
  }
  
  // 校验必要参数
  if (!formData.get('taskId')) {
    console.error('uploadTaskFile参数缺失：taskId不能为空');
    return Promise.reject(new Error('任务ID不能为空'));
  }
  
  return request({
    url: '/tasks/files/upload', // 后端文件上传接口地址
    method: 'post',
    data: formData,
    // 文件上传需配置的请求头（避免axios默认序列化）
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    // 可选：添加上传进度回调（如需显示进度条可启用）
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      console.log('文件上传进度：', percentCompleted + '%');
    }
  });
}

// ===== 新增：获取任务文件内容/下载链接 =====
/**
 * 获取任务文件详情（文本内容/下载链接）
 * @param {string} fileId - 文件ID
 * @param {string} [type='content'] - 获取类型：content(内容)/download(下载链接)
 * @returns {Promise} - 接口返回Promise
 */
export function getTaskFile(fileId, type = 'content') {
  // 参数校验
  if (!fileId || fileId.trim() === '') {
    console.error('getTaskFile参数错误：fileId不能为空');
    return Promise.reject(new Error('文件ID不能为空'));
  }
  
  const validTypes = ['content', 'download'];
  if (!validTypes.includes(type)) {
    console.error('getTaskFile参数错误：type必须为content或download');
    return Promise.reject(new Error(`获取类型错误，仅支持${validTypes.join('/')}`));
  }
  
  return request({
    url: `/tasks/files/${fileId.trim()}`, // 后端文件获取接口地址
    method: 'get',
    params: { type },
    // 文本文件需设置响应类型（避免乱码）
    responseType: type === 'content' ? 'text' : 'blob'
  });
}